import { keyframes } from 'styled-components';

export const shifts = {
  madrugada: { start: 0, end: 6 * 60 * 60 },
  manhã: { start: 6 * 60 * 60, end: 12 * 60 * 60 },
  tarde: { start: 12 * 60 * 60, end: 18 * 60 * 60 },
  noite: { start: 18 * 60 * 60, end: 24 * 60 * 60 },
};

export const groupsOfAis = {
  CAPITAL: [
    'AIS01',
    'AIS02',
    'AIS03',
    'AIS04',
    'AIS05',
    'AIS06',
    'AIS07',
    'AIS08',
    'AIS09',
    'AIS10',
  ],
  METROPOLITANA: ['AIS11', 'AIS12', 'AIS13', 'AIS23', 'AIS24', 'AIS25'],
  // INTERIOR: [
  //   'AIS14',
  //   'AIS15',
  //   'AIS16',
  //   'AIS17',
  //   'AIS18',
  //   'AIS19',
  //   'AIS20',
  //   'AIS21',
  //   'AIS22',
  // ],
};

export const aisLabels = [
  'AIS01',
  'AIS02',
  'AIS03',
  'AIS04',
  'AIS05',
  'AIS06',
  'AIS07',
  'AIS08',
  'AIS09',
  'AIS10',
  'AIS11',
  'AIS12',
  'AIS13',
  'AIS23',
  'AIS24',
  'AIS25',
];

export const formatHour = (hourFloat: number, selectedShift: string) => {
  // subtracting with shift to get right visualisation
  hourFloat -= indexOfShifts[selectedShift] * (6 * 60 * 60);

  const hours = Math.floor(hourFloat / (60 * 60));
  const minutes = Math.round((hourFloat - hours * 60 * 60) / 60);

  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}`;
};

const convertStringToTimeInSeconds = (str: string) => {
  let ans = 0;

  if (!str) return ans;

  const times = str.split(' ');

  times.map(time => {
    let multiplyer = 1;

    if (time[time.length - 1] === 'h') {
      multiplyer = 60 * 60;
    } else if (time[time.length - 1] === 'm') {
      multiplyer = 60;
    }

    let base = time.substring(0, time.length - 1);

    ans += Number(base) * multiplyer;
    return base;
  });

  return ans;
};

const indexOfShifts: { [key: string]: number } = {
  madrugada: 0,
  manhã: 1,
  tarde: 2,
  noite: 3,
};

const getValueOfGroupOfAis = (values: any[]) => {
  const ans = values.reduce((sum, item) => sum + item.purple, 0);
  return ans / values.length;
};

export const generateDataBarChart = (
  data: ReturnVtrEnpenhadas[],
  selectedShift: string,
  typeOfGroup: 'AIS' | 'REGION'
) => {
  try {
    let valuesByAis = aisLabels.map(ais => {
      const key = ais.toLocaleLowerCase();

      let purple = convertStringToTimeInSeconds(
        data[indexOfShifts[selectedShift]][key as keyof ReturnVtrEnpenhadas]
      );

      let orange = 6 * 60 * 60 - purple;

      return {
        ais,
        purple,
        orange,
      };
    });

    if (typeOfGroup === 'REGION') {
      return Object.entries(groupsOfAis).map(([key, value]) => {
        let purple = 0;
        if (key === 'CAPITAL') {
          purple = getValueOfGroupOfAis(valuesByAis.slice(0, 10));
        } else {
          purple = getValueOfGroupOfAis(valuesByAis.slice(10, 16));
        }

        let orange = 6 * 60 * 60 - purple;

        // multiplying with shift to get right visualization
        purple += indexOfShifts[selectedShift] * (6 * 60 * 60);
        orange += indexOfShifts[selectedShift] * (6 * 60 * 60);

        return {
          ais: key,
          purple,
          orange,
        };
      });
    }

    valuesByAis = valuesByAis.map(value => {
      // multiplying with shift to get right visualization
      const purple =
        value.purple + indexOfShifts[selectedShift] * (6 * 60 * 60);
      const orange =
        value.orange + indexOfShifts[selectedShift] * (6 * 60 * 60);

      return {
        ais: value.ais,
        purple,
        orange,
      };
    });

    return valuesByAis;
  } catch (e) {
    console.log('error building object', e);
  }
};

export const generateDataLineChart = ({
  total,
  empenhadas,
  ais,
}: {
  total: ReturnTotalVtrHora[];
  empenhadas: ReturnTotalVtrHora[];
  ais: string;
}) => {
  // Generate 24-hour time labels
  const hours = Array.from(
    { length: 25 },
    (_, i) => `${i.toString().padStart(2, '0')}:00`
  );

  return hours.map((hour, index) => ({
    hour,
    orange: total[index]
      ? Number(total[index][ais.toLowerCase() as keyof ReturnTotalVtrHora]) || 0
      : 0,
    purple: empenhadas[index]
      ? Number(
          empenhadas[index][ais.toLowerCase() as keyof ReturnTotalVtrHora]
        ) || 0
      : 0,
  }));
};
